import Joi from "joi";

const charctersPattern = new RegExp(
  "^[A-Za-z0-9\u0621-\u063A\ufe70-\ufeff\u0641-\u064A _][-0-9A-Za-z\\]\\[()\u0621-\u063A\ufe70-\ufeff\u0641-\u064A. _]+$"
);
export const ClassSchema = {
  className: Joi.string()
    .allow("")
    .trim()
    .required()
    .pattern(charctersPattern)
    .min(3)
    .max(60)
    .messages({
      "string.empty": "Class Name is required",
      "any.required": "Class Name is required",
      "string.max": "Class Name Validation",
      "string.min": "Class Name Validation",
      "string.pattern.base": "Class Name Validation",
    }),
  gradeId: Joi.number()
    .when("className", { is: Joi.string().min(3), then: Joi.required() })
    .messages({
      "number.empty": "Grade is required",
      "any.required": "Grade is required",
      "number.base": "Invalid grade name",
    }),
  teacherId: Joi.number()
    .when("className", { is: Joi.string().min(3), then: Joi.required() })
    .messages({
      "number.empty": "Teacher is required",
      "any.required": "Teacher is required",
      "number.base": "Invalid teacher name",
    }),
};

export default ClassSchema;
